import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { fetchCurrentUser } from '../../ducks/user.duck';
import {
  Footer,
  LayoutSideNavigation,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  Page,
  UserNav,
} from '../../components';
import { NRICSettingForm } from '../../forms';
import { TopbarContainer } from '../../containers';
import config from '../../config';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import css from './NRICSettingPage.css';

export const NRICSettingPageComponent = props => {
  const {
    currentUser,
    scrollingDisabled,
    intl,
  } = props;

  let tabs = [...config.custom.tabs];
  tabs = tabs.map(tab => ({...tab}));
  tabs[4].selected = true;

  const user = ensureCurrentUser(currentUser);
  const protectedData = user.attributes.profile.protectedData || {};
  const {

  } = protectedData;

  const NRICInfoForm = user.id ? (
    <NRICSettingForm
      className={css.form}
      initialValues={{  }}
      currentUser={currentUser}
      onSubmit={() => {}}
    />
  ) : null;

  const title = intl.formatMessage({ id: 'NRICSettingPage.title' });

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer
            currentPage="NRICSettingPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
          <UserNav selectedPageName="NRICSettingPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} user={user}/>
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.title}>
              <FormattedMessage id="NRICSettingPage.heading" />
            </h1>
            {NRICInfoForm}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

NRICSettingPageComponent.defaultProps = {
  currentUser: null,
};

const { bool } = PropTypes;

NRICSettingPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({

});

const NRICSettingPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(NRICSettingPageComponent);

NRICSettingPage.loadData = () => {
  // Since verify email happens in separate tab, current user's data might be updated
  return fetchCurrentUser();
};

export default NRICSettingPage;
